export default __webpack_public_path__ + "static/media/images-2-1.08783f87.jpg";